import Login from './Components/login'
import Extractos from './Components/extractos'
import { useEffect, useState } from 'react'
import './App.css'

function App() {
  const [user, setUser] = useState({})
  const [subUser, setSubUser] = useState(null)
  const [dataUser, setDataUser] = useState({})
  const params = new URLSearchParams(window.location.search)
  const handleChange = (e) => {
    setSubUser(e.target.value)
  }
  const handleclick = () => {
    fetch(`/api/user?cedula=${params.get('cedula') || subUser}&password=${encodeURIComponent(subUser?.slice(-4))}&token=${params.get('token')}`)
      .then(response => response.json())
      .then(data => {
        setDataUser(data)
        if (!user?.nombre) setUser(data)
      })
      .catch(err => console.error(err))
  }
  useEffect(()=>{
    if((!params.get('cedula') || !params.get('token')) && (!params.get('i') || !params.get('f'))) return
    handleclick()

  }, [])
  useEffect(()=>{
    if(!window.location.pathname.includes('sms')) return
    window.location.href = `/api/${window.location.pathname}`
  }, [])
  return (
    <>
      {
        user?.nombre ? 
          user?.admin ?
            <>
              {
                dataUser?.nombre ?
                  <>
                    <Extractos usuario={dataUser}/>
                    <button onClick={() => setDataUser({})}>Volver</button>
                  </>
                  :<>
                    <img src="/coop-logo.png" alt="" />
                    <div className='div-login'>
                      <p className='p-login'>Cedula a buscar</p>
                      <input onChange={handleChange} className='input-login' type='text' placeholder='Cedula a buscar'/>
                      <button onClick={handleclick} className='button-login'>Buscar</button>
                    </div>
                  </>
              }
            </>
            :<Extractos usuario={user}/> 
          :<Login loginUser={setUser}/>
      }
      <p>©By Sygma</p>
    </>
  )
}

export default App
